import { render, staticRenderFns } from "./PageSimulation.vue?vue&type=template&id=f7558ca4&scoped=true"
import script from "./PageSimulation.vue?vue&type=script&lang=ts"
export * from "./PageSimulation.vue?vue&type=script&lang=ts"
import style0 from "./PageSimulation.vue?vue&type=style&index=0&id=f7558ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7558ca4",
  null
  
)

export default component.exports